import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ContratosService } from '@services/contratos/contratos.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { TiposMoviemientoService } from '@services/tipos-movimiento/tipos-movimiento.service';
import { default as _rollupMoment, Moment } from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import * as _moment from 'moment';
import { TipoMovimientoDto } from '@models/tipos-movimiento/tipoMovimientoDto.model';
import { MovimientosService } from '@services/movimientos/movimientos.service';
import { CreateMovimientoRequest } from '@models/movimiento/createMovimientoRequest.mode';
import { AccionesDialog, EstadosContrato, TiposMovimiento } from '@models/base/identificadores.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContratoDetailDto } from '@models/contrato/contratoDetailDto.model';
import { PropietariosService } from '@services/propietarios/propietarios.service';
import { PropietarioDto } from '@models/propietarios/propietarioDto.model';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-dialog-imputacion-propietario',
  templateUrl: './dialog-imputacion-propietario.component.html',
  styleUrls: ['./dialog-imputacion-propietario.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    [DatePipe],
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class DialogImputacionPropietarioComponent implements OnInit {

  @Input() idPropietario!: number

  formBuilder: FormBuilder = new FormBuilder;
  movimientoForm: any;
  lstTiposMovimiento!: TipoMovimientoDto[];
  /** Id que el buscador de tipo de movimiento muestra preseleccionado */
  idTipoMovimientoSeleccionado: number | null = null
  /** Tipo elegido, sólo para informar si genera comisión o no */
  tipoMovimientoSeleccionado: TipoMovimientoDto | null = null
  contratosPropietario!: ContratoDetailDto[];
  lstPropietarios!: PropietarioDto[];
  get f() { return this.movimientoForm.controls; }

  contratoDetailDto!: ContratoDetailDto

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<DialogImputacionPropietarioComponent>,
    private tiposMoviemientoService: TiposMoviemientoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private contratoService: ContratosService,
    private movimientosService: MovimientosService,
    public datepipe: DatePipe,
    private propietariosService: PropietariosService,
  ) {
    this.movimientoForm = this.formBuilder.group({
      TipoMovimiento: ["", Validators.required],
      Descripcion: ["", Validators.maxLength(2000)],
      Contrato: [""],
      Importe: ["", Validators.required],
      FechaEmision: [moment(), Validators.required],
    })
    if (!isFalsy(this.data))
      this.contratoDetailDto = this.data
  }

  ngOnInit(): void {
    this.getAllTiposMovimientos()
  }

  getAllTiposMovimientos() {
    this.spinner.show("spBusquedaTiposMovimiento")
    this.tiposMoviemientoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaTiposMovimiento")
          this.lstTiposMovimiento = data.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
        },
        error => {
          this.spinner.hide("spBusquedaTiposMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllPropietarios() {
    this.spinner.show("spBusquedaPropietarios")
    this.propietariosService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spBusquedaPropietarios")
          this.lstPropietarios = data
        },
        error => {
          this.spinner.hide("spBusquedaPropietarios")
          this.snackBar.showError(error, "Error");
        })
  }

  onSubmit() {
    if (isFalsy(this.contratoDetailDto))
      this.contratoDetailDto = this.movimientoForm.controls["Contrato"].value[0];

    if (!isFalsy(this.contratoDetailDto)) {
      let createMovimientoRequest = this.setCreateMovimientoRequest();
      if (createMovimientoRequest) {
        this.createMovimiento(createMovimientoRequest);
      }
    }
  }

  selectPropietario(event: any) {
    this.getAllContratosByIdPropietario(event.id_Propietario)
  }

  setCreateMovimientoRequest(): CreateMovimientoRequest {
    let tipoMovimientoId = this.movimientoForm.controls["TipoMovimiento"].value
    let descripcion = this.movimientoForm.controls["Descripcion"].value == "" ? null : this.movimientoForm.controls["Descripcion"].value
    let importe = this.movimientoForm.controls["Importe"].value == "" ? null : parseFloat(this.movimientoForm.controls["Importe"].value)

    // Obtener periodoMes y periodoAnio desde FechaEmision
    let fechaEmision = this.movimientoForm.controls["FechaEmision"].value
    let periodoAnio = fechaEmision ? fechaEmision.year() : null
    let periodoMes = fechaEmision ? fechaEmision.month() + 1 : null // +1 porque moment.month() retorna 0-11
    let fechaEmisionStr = this.datepipe.transform(fechaEmision, 'yyyy-MM-dd');

    let createMovimientoRequest: CreateMovimientoRequest = new CreateMovimientoRequest
    createMovimientoRequest.descripcion = descripcion
    createMovimientoRequest.idTipoMovimiento = tipoMovimientoId
    createMovimientoRequest.importe = importe
    createMovimientoRequest.periodo = 0
    createMovimientoRequest.periodoAnio = periodoAnio
    createMovimientoRequest.periodoMes = periodoMes
    createMovimientoRequest.idContrato = this.contratoDetailDto.id
    createMovimientoRequest.idPropiedad = this.contratoDetailDto.propiedad.id
    createMovimientoRequest.idInquilino = null
    // La comisión NO la decide el usuario: la define TieneComision del tipo de
    // movimiento, que se resuelve al liquidar. Se manda false siempre.
    createMovimientoRequest.aplicarComision = false;

    this.contratoDetailDto.propietarios.forEach(propietario => {
      if (propietario.titular == true)
        createMovimientoRequest.idPropietario = propietario.id
    });

    createMovimientoRequest.fechaEmision = fechaEmisionStr
    createMovimientoRequest.fechaPago = null
    createMovimientoRequest.idBonificacion = null
    createMovimientoRequest.idMovimientoRef = null
    createMovimientoRequest.idPeriodoContrato = null

    return createMovimientoRequest
  }

  /** El buscador devuelve el DTO; el formulario sigue guardando el id. */
  selectTipoMovimiento(tipoMovimiento: TipoMovimientoDto | null) {
    this.movimientoForm.controls["TipoMovimiento"].setValue(tipoMovimiento ? tipoMovimiento.id : "")
    this.idTipoMovimientoSeleccionado = tipoMovimiento ? tipoMovimiento.id : null

    if (tipoMovimiento)
      this.onTipoMovimientoChange(tipoMovimiento.id)
  }

  onTipoMovimientoChange(idTipoMovimiento: number) {
    this.tipoMovimientoSeleccionado = this.lstTiposMovimiento.find(t => t.id === idTipoMovimiento) ?? null;
  }

  setCreateMovimientoComisioRequest(): CreateMovimientoRequest {
    let descripcion = this.movimientoForm.controls["Descripcion"].value == "" ? null : this.movimientoForm.controls["Descripcion"].value
    let importe = this.movimientoForm.controls["Importe"].value == "" ? 0 : parseFloat(this.movimientoForm.controls["Importe"].value)

    // Obtener periodoMes y periodoAnio desde FechaEmision
    let fechaEmision = this.movimientoForm.controls["FechaEmision"].value
    let periodoAnio = fechaEmision ? fechaEmision.year() : null
    let periodoMes = fechaEmision ? fechaEmision.month() + 1 : null
    let fechaEmisionStr = this.datepipe.transform(fechaEmision, 'yyyy-MM-dd');

    let createMovimientoRequest: CreateMovimientoRequest = new CreateMovimientoRequest
    createMovimientoRequest.descripcion = "Comisión: " + (isFalsy(descripcion) ? "" : descripcion)
    createMovimientoRequest.idTipoMovimiento = TiposMovimiento.ComisionInmobiliaria

    if (!isFalsy(this.contratoDetailDto.porcentajeComisionPropietario))
      createMovimientoRequest.importe = (importe * this.contratoDetailDto.porcentajeComisionPropietario) / 100
    else
      createMovimientoRequest.importe = importe

    createMovimientoRequest.periodo = 0
    createMovimientoRequest.periodoAnio = periodoAnio
    createMovimientoRequest.periodoMes = periodoMes
    createMovimientoRequest.idContrato = this.contratoDetailDto.id
    createMovimientoRequest.idPropiedad = this.contratoDetailDto.propiedad.id
    createMovimientoRequest.idInquilino = null

    this.contratoDetailDto.propietarios.forEach(propietario => {
      if (propietario.titular == true)
        createMovimientoRequest.idPropietario = propietario.id
    });

    createMovimientoRequest.fechaEmision = fechaEmisionStr
    createMovimientoRequest.fechaPago = null
    createMovimientoRequest.idBonificacion = null
    createMovimientoRequest.idMovimientoRef = null
    createMovimientoRequest.idPeriodoContrato = null

    return createMovimientoRequest
  }

  createMovimiento(createMovimientoRequest: CreateMovimientoRequest) {
    this.spinner.show("spMovimiento")
    this.movimientosService.create(createMovimientoRequest)
      .subscribe(
        data => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showSuccess("Movimiento creado correctamente.", "Éxito")
          this.dialogRef.close({ event: AccionesDialog.Agregar });
        },
        error => {
          this.spinner.hide("spMovimiento")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllContratosByIdPropietario(idPropietario: number) {
    this.spinner.show("spAllContratosPropietario")
    this.contratoService.getAllByIdPropietario(idPropietario, EstadosContrato.Activo)
      .subscribe(
        data => {
          this.spinner.hide("spAllContratosPropietario")
          this.contratosPropietario = data
        },
        error => {
          this.spinner.hide("spAllContratosPropietario")
          this.snackBar.showError(error, "Error");
        })
  }

  closeDialog() {
    this.dialogRef.close({ event: AccionesDialog.Cancelar });
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
